export const apiUrl = (window as any).apiUrl;
